import React from "react";
import { Link } from "react-router-dom";

function SimilarProductsDynamic({ products, handleClick }) {
  const defaultProducts = [
    {
      picture: "assets/images/20-kg/1.webp",
      title: "WC Banyo Temizleyici",
      nav: "/wcbanyotemizleyici"
    }
  ];

  const displayProducts = products || defaultProducts;

  return (
    <section className="section-space-bottom">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="section-title text-center mb-5">
              <h3 className="section-title__title">BENZER ÜRÜNLER</h3>
            </div>
          </div>
        </div>
        <div className="row justify-content-center">
          {displayProducts.map((product, index) => (
            <div key={index} className="col-md-4 mb-4">
              <div className="product__item wow fadeInUp" data-wow-duration="1500ms" data-wow-delay={`${index * 100}ms`}>
                <div className="product__item__image">
                  <img src={product.picture} alt={product.title} />
                </div>
                <div className="product__item__content">
                  <div className="boskery-ratings">
                    <span className="icon-star"></span>
                    <span className="icon-star"></span>
                    <span className="icon-star"></span>
                    <span className="icon-star"></span>
                    <span className="icon-star"></span>
                  </div>
                  <h4 className="product__item__title">
                    <Link as={Link} to={product.nav} onClick={handleClick}>
                      {product.title}
                    </Link>
                  </h4>
                  <Link to={product.nav} className="boskery-btn" onClick={handleClick}>
                    <span className="boskery-btn__hover"></span>
                    <span className="boskery-btn__hover"></span>
                    <span className="boskery-btn__hover"></span>
                    <span className="boskery-btn__hover"></span>
                    <span className="boskery-btn__hover"></span>
                    <span className="boskery-btn__hover"></span>
                    <span className="boskery-btn__text">detaylar</span>
                    <i className="icon-arrow-right"></i>
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default SimilarProductsDynamic;